var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contact-small",attrs:{"href":_vm.contact.link,"width":"50px","height":"50px"}},[_c('img',{staticClass:"icon-small",attrs:{"src":require(`../assets/${_vm.contact.img}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }